import React, { useState } from 'react'
import buyerAiCard from '../../../assets/new-home/buyer-page/buyer-ai-graphic-optimized.jpg'
import buyerWarehouse from '../../../assets/new-home/buyer-page/buyer-ai-card-optimized.jpg'
import tickIcon from '../../../assets/new-home/tick.svg'
import AnimateFromBottom from '../../LandingPage/component/AnimateFromBottom'
import language from '../../../helpers/language'

const imgs = [buyerAiCard, null, buyerWarehouse]

const VisualCard = ({ section }) => (
  <div className={`relative w-full max-w-md overflow-visible pb-24 sm:pb-28 ${section.reverse ? 'mr-auto' : 'ml-auto'}`}>
    {section.img ? (
      <img
        src={section.img}
        alt={section.badge}
        loading="lazy"
        decoding="async"
        className={`w-[82%] h-56 md:h-64 object-cover rounded-lg shadow-sm ${section.reverse ? 'mr-auto' : 'ml-auto'}`}
      />
    ) : (
      <div className={`w-[82%] h-56 md:h-64 rounded-lg bg-gray-200 shadow-sm ${section.reverse ? 'mr-auto' : 'ml-auto'}`} />
    )}

    <div
      className={`absolute z-10 left-4 bottom-4 rounded p-4 shadow-lg w-32 sm:w-36 md:w-44 min-h-[128px] flex flex-col justify-center ${section.reverse ? 'left-auto right-4' : ''}`}
      style={{ background: section.statColor }}
    >
      <p className="text-white font-extrabold text-2xl sm:text-3xl leading-none mb-7 whitespace-nowrap">
        {section.stat.value}
      </p>
      <p className="text-white text-xs leading-snug">
        {section.stat.label}
      </p>
    </div>
  </div>
)

const BuyerImages = () => {
  const [lang] = useState(language.getLang())
  const sections = (lang?.buyerImages || []).map((s, i) => ({ ...s, img: imgs[i] }))

  return (
    <>
      {sections.map((section, idx) => (
        <section key={idx} className="md:py-16 py-10">
          <div className="mx-auto max-w-6xl px-6 sm:px-8 lg:px-10">
            <div className={`flex flex-col ${section.reverse ? 'md:flex-row-reverse' : 'md:flex-row'} gap-12 md:gap-16 lg:gap-20 items-start`}>
              <div className="flex-1 md:basis-7/12">
                <AnimateFromBottom delay={0.1}>
                  <span className="inline-block border border-royal text-royal text-xs font-semibold px-4 py-1.5 rounded mb-5">
                    {section.badge}
                  </span>
                </AnimateFromBottom>
                <div className="mb-7">
                  <AnimateFromBottom delay={0.2}>
                    <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 leading-tight">
                      {section.heading}
                    </h2>
                  </AnimateFromBottom>
                </div>
                <div className="mb-7">
                  <AnimateFromBottom delay={0.3}>
                    <p className="text-sm text-gray-500 leading-relaxed">
                      {section.desc}
                    </p>
                  </AnimateFromBottom>
                </div>
                <AnimateFromBottom delay={0.4}>
                  <ul className="flex flex-col gap-4">
                    {section.bullets.map((bullet, i) => (
                      <li key={i} className="flex items-start gap-3 text-sm font-bold text-gray-900">
                        <img src={tickIcon} alt="" className="flex-shrink-0 mt-0.5" style={{ width: '17px', height: '16px' }} />
                        {bullet}
                      </li>
                    ))}
                  </ul>
                </AnimateFromBottom>
              </div>

              <div className="flex-1 md:basis-5/12 w-full mt-6 md:mt-16">
                <AnimateFromBottom delay={0.2}>
                  <VisualCard section={section} />
                </AnimateFromBottom>
              </div>
            </div>
          </div>
        </section>
      ))}
    </>
  )
}

export default BuyerImages
